module.exports = __webpack_public_path__ + "static/media/banner-1.88e73202.jpeg";